import { useMutation } from '@tanstack/react-query'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { throwIfApiError } from '@omnea-app/packages/universal/error-handling/throwifApiError'
import { RequestsHttpClient } from '@omnea-app/requests/requestsHttpClient'

export const useInsertPauseReason = () => {
  const { getToken } = useAuthenticatedUser()

  return useMutation({
    mutationFn: async ({ reason }: { reason: string }) => {
      const apiClient = new RequestsHttpClient({ authorization: await getToken() })

      const { data, error } = await apiClient.POST('/pause-reasons', {
        body: {
          text: reason,
        },
      })

      throwIfApiError(error)

      return data
    },
  })
}
